export class GetDeviceLocationRequest {
  public ID: number;
  public StartTime: number;
  public EndTime: number;
  public Count?: number;
  public LAC: number;
  public MCC?: number;
  public MNC?: number;
  public CellID: number;
  public DistinctTowers?: boolean;
  public Operator?: string | null;
  public Search?: string;
  public DeviceIds?: number[];

  constructor() {}
}
